@file:OptIn(InternalResourceApi::class)

package com.nonopn.skywatcher.common.app.res

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/com.nonopn.skywatcher.common.app.res/"

@delegate:ResourceContentHash(1_151_807_679)
internal val Res.string.cert_incidence_indirect_only: StringResource by lazy {
      StringResource("string:cert_incidence_indirect_only", "cert_incidence_indirect_only", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7154, 112),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7246, 108),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 6950, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6658, 100),
      ))
    }

@delegate:ResourceContentHash(-2_011_366_746)
internal val Res.string.cert_incidence_probability_desc: StringResource by lazy {
      StringResource("string:cert_incidence_probability_desc", "cert_incidence_probability_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7267, 159),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7355, 147),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 7063, 155),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6759, 143),
      ))
    }

@delegate:ResourceContentHash(-2_100_577_659)
internal val Res.string.cert_incidence_probability_title: StringResource by lazy {
      StringResource("string:cert_incidence_probability_title", "cert_incidence_probability_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7427, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7503, 72),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 7219, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6903, 68),
      ))
    }

@delegate:ResourceContentHash(-1_258_972_799)
internal val Res.string.cert_incidence_unlikely: StringResource by lazy {
      StringResource("string:cert_incidence_unlikely", "cert_incidence_unlikely", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7504, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7576, 95),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 7300, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6972, 87),
      ))
    }

@delegate:ResourceContentHash(-2_064_425_255)
internal val Res.string.cert_nsg_avg_intensity: StringResource by lazy {
      StringResource("string:cert_nsg_avg_intensity", "cert_nsg_avg_intensity", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7600, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7672, 54),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 7396, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7060, 54),
      ))
    }

@delegate:ResourceContentHash(1_221_199_551)
internal val Res.string.cert_nsg_avg_sensors: StringResource by lazy {
      StringResource("string:cert_nsg_avg_sensors", "cert_nsg_avg_sensors", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7655, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7727, 48),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 7451, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7115, 48),
      ))
    }

@delegate:ResourceContentHash(-1_983_535_509)
internal val Res.string.cert_nsg_comparison_section: StringResource by lazy {
      StringResource("string:cert_nsg_comparison_section", "cert_nsg_comparison_section", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7708, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7776, 87),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 7504, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7164, 75),
      ))
    }

@delegate:ResourceContentHash(-106_091_764)
internal val Res.string.cert_nsg_density_section: StringResource by lazy {
      StringResource("string:cert_nsg_density_section", "cert_nsg_density_section", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7796, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7864, 84),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 7592, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7240, 76),
      ))
    }

@delegate:ResourceContentHash(-38_829_229)
internal val Res.string.cert_nsg_density_title: StringResource by lazy {
      StringResource("string:cert_nsg_density_title", "cert_nsg_density_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7869, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7949, 82),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 7669, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7317, 70),
      ))
    }

@delegate:ResourceContentHash(-945_413_094)
internal val Res.string.cert_nsg_detected_impacts: StringResource by lazy {
      StringResource("string:cert_nsg_detected_impacts", "cert_nsg_detected_impacts", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7944, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8032, 57),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 7744, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7388, 57),
      ))
    }

@delegate:ResourceContentHash(-2_103_100_516)
internal val Res.string.cert_nsg_level_high: StringResource by lazy {
      StringResource("string:cert_nsg_level_high", "cert_nsg_level_high", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8006, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8090, 39),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 7802, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7446, 35),
      ))
    }

@delegate:ResourceContentHash(1_643_546_939)
internal val Res.string.cert_nsg_level_low: StringResource by lazy {
      StringResource("string:cert_nsg_level_low", "cert_nsg_level_low", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8042, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8130, 34),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 7838, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7482, 30),
      ))
    }

@delegate:ResourceContentHash(1_237_788_624)
internal val Res.string.cert_nsg_level_moderate: StringResource by lazy {
      StringResource("string:cert_nsg_level_moderate", "cert_nsg_level_moderate", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8077, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8165, 43),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 7873, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7513, 43),
      ))
    }

@delegate:ResourceContentHash(229_239_132)
internal val Res.string.cert_nsg_location_label: StringResource by lazy {
      StringResource("string:cert_nsg_location_label", "cert_nsg_location_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8121, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8209, 47),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 7917, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7557, 43),
      ))
    }

@delegate:ResourceContentHash(-873_475_118)
internal val Res.string.cert_nsg_max_intensity: StringResource by lazy {
      StringResource("string:cert_nsg_max_intensity", "cert_nsg_max_intensity", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8173, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8257, 50),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 7969, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7601, 50),
      ))
    }

@delegate:ResourceContentHash(45_039_974)
internal val Res.string.cert_nsg_measured_label: StringResource by lazy {
      StringResource("string:cert_nsg_measured_label", "cert_nsg_measured_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8228, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8308, 67),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 8024, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7652, 71),
      ))
    }

@delegate:ResourceContentHash(-1_001_027_127)
internal val Res.string.cert_nsg_measured_network: StringResource by lazy {
      StringResource("string:cert_nsg_measured_network", "cert_nsg_measured_network", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8296, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8376, 77),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 8088, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7724, 77),
      ))
    }

@delegate:ResourceContentHash(-1_550_739_532)
internal val Res.string.cert_nsg_median_intensity: StringResource by lazy {
      StringResource("string:cert_nsg_median_intensity", "cert_nsg_median_intensity", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8366, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8454, 61),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 8158, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7802, 57),
      ))
    }

@delegate:ResourceContentHash(1_790_153_636)
internal val Res.string.cert_nsg_methodology: StringResource by lazy {
      StringResource("string:cert_nsg_methodology", "cert_nsg_methodology", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8424, 384),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8516, 372),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 8220, 368),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7860, 352),
      ))
    }

@delegate:ResourceContentHash(-1_422_316_661)
internal val Res.string.cert_nsg_no_notable_impacts: StringResource by lazy {
      StringResource("string:cert_nsg_no_notable_impacts", "cert_nsg_no_notable_impacts", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8809, 215),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8889, 211),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 8589, 203),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8213, 195),
      ))
    }

@delegate:ResourceContentHash(1_891_481_844)
internal val Res.string.cert_nsg_notable_activity_title: StringResource by lazy {
      StringResource("string:cert_nsg_notable_activity_title", "cert_nsg_notable_activity_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9025, 103),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9101, 99),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 8793, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8409, 95),
      ))
    }

@delegate:ResourceContentHash(1_685_534_868)
internal val Res.string.cert_nsg_notable_values: StringResource by lazy {
      StringResource("string:cert_nsg_notable_values", "cert_nsg_notable_values", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9129, 171),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9201, 175),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 8893, 167),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8505, 147),
      ))
    }

@delegate:ResourceContentHash(-1_167_088_560)
internal val Res.string.cert_nsg_period_suffix: StringResource by lazy {
      StringResource("string:cert_nsg_period_suffix", "cert_nsg_period_suffix", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9301, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9377, 58),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 9061, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8653, 58),
      ))
    }

@delegate:ResourceContentHash(1_565_660_686)
internal val Res.string.cert_nsg_share_title: StringResource by lazy {
      StringResource("string:cert_nsg_share_title", "cert_nsg_share_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9368, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9436, 60),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 9124, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8712, 60),
      ))
    }

@delegate:ResourceContentHash(-1_666_442_628)
internal val Res.string.cert_nsg_standards_text: StringResource by lazy {
      StringResource("string:cert_nsg_standards_text", "cert_nsg_standards_text", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9429, 363),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9497, 387),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 9185, 371),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8773, 375),
      ))
    }

@delegate:ResourceContentHash(2_043_735_102)
internal val Res.string.cert_nsg_standards_title: StringResource by lazy {
      StringResource("string:cert_nsg_standards_title", "cert_nsg_standards_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9793, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9885, 64),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 9557, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9149, 60),
      ))
    }

@delegate:ResourceContentHash(2_075_710_520)
internal val Res.string.cert_nsg_title: StringResource by lazy {
      StringResource("string:cert_nsg_title", "cert_nsg_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9858, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9950, 42),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 9622, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9210, 42),
      ))
    }

@delegate:ResourceContentHash(1_996_266_618)
internal val Res.string.cert_nsg_vs_ng: StringResource by lazy {
      StringResource("string:cert_nsg_vs_ng", "cert_nsg_vs_ng", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9950, 490),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10042, 502),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 9714, 458),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9302, 462),
      ))
    }

@delegate:ResourceContentHash(818_430_656)
internal val Res.string.cert_nsg_vs_ng_title: StringResource by lazy {
      StringResource("string:cert_nsg_vs_ng_title", "cert_nsg_vs_ng_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9901, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9993, 48),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 9665, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9253, 48),
      ))
    }

@delegate:ResourceContentHash(489_407_964)
internal val Res.string.cert_nsg_your_site: StringResource by lazy {
      StringResource("string:cert_nsg_your_site", "cert_nsg_your_site", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10441, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10545, 46),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 10173, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9765, 46),
      ))
    }

@delegate:ResourceContentHash(335_637_841)
internal val Res.string.cert_nsg_zone_0_1km: StringResource by lazy {
      StringResource("string:cert_nsg_zone_0_1km", "cert_nsg_zone_0_1km", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10484, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10592, 51),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 10220, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9812, 51),
      ))
    }

@delegate:ResourceContentHash(-1_781_801_657)
internal val Res.string.cert_nsg_zone_1_2km: StringResource by lazy {
      StringResource("string:cert_nsg_zone_1_2km", "cert_nsg_zone_1_2km", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10536, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10644, 51),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 10268, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9864, 51),
      ))
    }

@delegate:ResourceContentHash(-820_151_097)
internal val Res.string.cert_nsg_zone_network: StringResource by lazy {
      StringResource("string:cert_nsg_zone_network", "cert_nsg_zone_network", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10588, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10696, 77),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 10316, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9916, 77),
      ))
    }

@delegate:ResourceContentHash(1_243_468_684)
internal val Res.string.cert_physical_damage: StringResource by lazy {
      StringResource("string:cert_physical_damage", "cert_physical_damage", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10662, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10774, 64),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 10390, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9994, 64),
      ))
    }

@delegate:ResourceContentHash(1_855_803_571)
internal val Res.string.cert_reco_check_equipment: StringResource by lazy {
      StringResource("string:cert_reco_check_equipment", "cert_reco_check_equipment", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10723, 177),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10839, 189),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 10447, 181),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10059, 169),
      ))
    }

@delegate:ResourceContentHash(-285_233_535)
internal val Res.string.cert_reco_inspect: StringResource by lazy {
      StringResource("string:cert_reco_inspect", "cert_reco_inspect", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10901, 205),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11029, 193),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 10629, 189),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10229, 169),
      ))
    }

@delegate:ResourceContentHash(-1_103_971_802)
internal val Res.string.cert_reco_insurance: StringResource by lazy {
      StringResource("string:cert_reco_insurance", "cert_reco_insurance", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11107, 155),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11223, 179),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 10819, 151),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10399, 131),
      ))
    }

@delegate:ResourceContentHash(-1_215_458_323)
internal val Res.string.cert_reco_monitoring: StringResource by lazy {
      StringResource("string:cert_reco_monitoring", "cert_reco_monitoring", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11263, 212),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11403, 228),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 10971, 212),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10531, 192),
      ))
    }

@delegate:ResourceContentHash(-756_039_307)
internal val Res.string.cert_reco_no_action: StringResource by lazy {
      StringResource("string:cert_reco_no_action", "cert_reco_no_action", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11476, 207),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11632, 219),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 11184, 203),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10724, 187),
      ))
    }

@delegate:ResourceContentHash(-1_008_047_355)
internal val Res.string.cert_reco_surge_protectors: StringResource by lazy {
      StringResource("string:cert_reco_surge_protectors", "cert_reco_surge_protectors", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11684, 178),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11852, 158),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 11388, 178),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10912, 138),
      ))
    }

@delegate:ResourceContentHash(250_531_797)
internal val Res.string.cert_reco_verify: StringResource by lazy {
      StringResource("string:cert_reco_verify", "cert_reco_verify", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11863, 188),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12011, 204),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 11567, 184),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11051, 152),
      ))
    }

@delegate:ResourceContentHash(-785_958_379)
internal val Res.string.checkout_return_activated: StringResource by lazy {
      StringResource("string:checkout_return_activated", "checkout_return_activated", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12052, 105),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12216, 101),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 11752, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11204, 105),
      ))
    }

@delegate:ResourceContentHash(2_016_809_209)
internal val Res.string.checkout_return_activating: StringResource by lazy {
      StringResource("string:checkout_return_activating", "checkout_return_activating", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12158, 118),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12318, 130),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 11862, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11310, 126),
      ))
    }

@delegate:ResourceContentHash(-2_006_797_014)
internal val Res.string.checkout_return_cancel_text: StringResource by lazy {
      StringResource("string:checkout_return_cancel_text", "checkout_return_cancel_text", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12277, 159),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12449, 171),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 11989, 155),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11437, 123),
      ))
    }

@delegate:ResourceContentHash(2_126_830_929)
internal val Res.string.checkout_return_cancel_title: StringResource by lazy {
      StringResource("string:checkout_return_cancel_title", "checkout_return_cancel_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12437, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12621, 68),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 12145, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11561, 64),
      ))
    }

@delegate:ResourceContentHash(548_374_915)
internal val Res.string.checkout_return_close: StringResource by lazy {
      StringResource("string:checkout_return_close", "checkout_return_close", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12498, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12690, 37),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 12218, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11626, 37),
      ))
    }

@delegate:ResourceContentHash(-1_574_665_226)
internal val Res.string.checkout_return_delayed: StringResource by lazy {
      StringResource("string:checkout_return_delayed", "checkout_return_delayed", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12536, 195),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12728, 191),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 12256, 203),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11664, 179),
      ))
    }

@delegate:ResourceContentHash(744_478_600)
internal val Res.string.checkout_return_login_needed: StringResource by lazy {
      StringResource("string:checkout_return_login_needed", "checkout_return_login_needed", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12732, 132),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12920, 128),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 12460, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11844, 116),
      ))
    }

@delegate:ResourceContentHash(1_257_563_712)
internal val Res.string.checkout_return_signing_in: StringResource by lazy {
      StringResource("string:checkout_return_signing_in", "checkout_return_signing_in", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12865, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13049, 74),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 12585, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11961, 58),
      ))
    }

@delegate:ResourceContentHash(189_504_657)
internal val Res.string.checkout_return_success_title: StringResource by lazy {
      StringResource("string:checkout_return_success_title", "checkout_return_success_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12928, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13124, 77),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 12652, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12020, 61),
      ))
    }

@delegate:ResourceContentHash(320_442_199)
internal val Res.string.confirm: StringResource by lazy {
      StringResource("string:confirm", "confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13002, 27),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13202, 27),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 12714, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12082, 27),
      ))
    }

@delegate:ResourceContentHash(446_069_918)
internal val Res.string.consultation_expired: StringResource by lazy {
      StringResource("string:consultation_expired", "consultation_expired", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13030, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13230, 64),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 12742, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12110, 60),
      ))
    }

@delegate:ResourceContentHash(2_117_323_735)
internal val Res.string.consultation_loading: StringResource by lazy {
      StringResource("string:consultation_loading", "consultation_loading", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13099, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13295, 64),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 12807, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12171, 56),
      ))
    }

@delegate:ResourceContentHash(-1_562_967_835)
internal val Res.string.consultation_provided_by: StringResource by lazy {
      StringResource("string:consultation_provided_by", "consultation_provided_by", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13156, 120),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13360, 96),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 12868, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12228, 96),
      ))
    }

@delegate:ResourceContentHash(639_402_244)
internal val Res.string.consultation_shared_info: StringResource by lazy {
      StringResource("string:consultation_shared_info", "consultation_shared_info", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13277, 168),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13457, 156),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 12969, 156),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12325, 156),
      ))
    }

@delegate:ResourceContentHash(-960_197_728)
internal val Res.string.consultation_title: StringResource by lazy {
      StringResource("string:consultation_title", "consultation_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13446, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13614, 58),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 13126, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12482, 46),
      ))
    }

@delegate:ResourceContentHash(-1_997_678_358)
internal val Res.string.dashboard_daily_chart_title: StringResource by lazy {
      StringResource("string:dashboard_daily_chart_title", "dashboard_daily_chart_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13501, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13673, 67),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 13189, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12529, 59),
      ))
    }

@delegate:ResourceContentHash(-2_091_164_405)
internal val Res.string.dashboard_header_12months: StringResource by lazy {
      StringResource("string:dashboard_header_12months", "dashboard_header_12months", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13565, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13741, 73),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 13257, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12589, 73),
      ))
    }

@delegate:ResourceContentHash(1_924_410_521)
internal val Res.string.dashboard_header_30days: StringResource by lazy {
      StringResource("string:dashboard_header_30days", "dashboard_header_30days", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13643, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13815, 63),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 13335, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12663, 55),
      ))
    }

@delegate:ResourceContentHash(-321_605_568)
internal val Res.string.dashboard_header_90days: StringResource by lazy {
      StringResource("string:dashboard_header_90days", "dashboard_header_90days", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13707, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13879, 63),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 13395, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12719, 55),
      ))
    }

@delegate:ResourceContentHash(1_137_642_350)
internal val Res.string.dashboard_header_today: StringResource by lazy {
      StringResource("string:dashboard_header_today", "dashboard_header_today", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13771, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13943, 62),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 13455, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12775, 54),
      ))
    }

@delegate:ResourceContentHash(-1_766_709_683)
internal val Res.string.dashboard_impacts_cg: StringResource by lazy {
      StringResource("string:dashboard_impacts_cg", "dashboard_impacts_cg", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13826, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14006, 48),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 13510, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12830, 48),
      ))
    }

@delegate:ResourceContentHash(-263_225_153)
internal val Res.string.dashboard_including_today: StringResource by lazy {
      StringResource("string:dashboard_including_today", "dashboard_including_today", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13879, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14055, 61),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 13563, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12879, 61),
      ))
    }

@delegate:ResourceContentHash(2_000_820_841)
internal val Res.string.dashboard_loading_error: StringResource by lazy {
      StringResource("string:dashboard_loading_error", "dashboard_loading_error", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13945, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14117, 79),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 13625, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12941, 59),
      ))
    }

@delegate:ResourceContentHash(299_340_215)
internal val Res.string.dashboard_monthly_chart_title: StringResource by lazy {
      StringResource("string:dashboard_monthly_chart_title", "dashboard_monthly_chart_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14021, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14197, 65),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 13705, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13001, 65),
      ))
    }

@delegate:ResourceContentHash(384_422_697)
internal val Res.string.dashboard_no_data: StringResource by lazy {
      StringResource("string:dashboard_no_data", "dashboard_no_data", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14091, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14263, 45),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 13771, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13067, 37),
      ))
    }

@delegate:ResourceContentHash(-1_358_075_882)
internal val Res.string.dashboard_no_impact_in_period: StringResource by lazy {
      StringResource("string:dashboard_no_impact_in_period", "dashboard_no_impact_in_period", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14129, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14309, 81),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 13809, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13105, 69),
      ))
    }

@delegate:ResourceContentHash(617_943_307)
internal val Res.string.dashboard_period_month: StringResource by lazy {
      StringResource("string:dashboard_period_month", "dashboard_period_month", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14207, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14391, 42),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 13887, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13175, 42),
      ))
    }

@delegate:ResourceContentHash(-935_530_432)
internal val Res.string.dashboard_period_quarter: StringResource by lazy {
      StringResource("string:dashboard_period_quarter", "dashboard_period_quarter", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14250, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14434, 40),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 13930, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13218, 44),
      ))
    }

@delegate:ResourceContentHash(-1_891_978_171)
internal val Res.string.dashboard_period_today: StringResource by lazy {
      StringResource("string:dashboard_period_today", "dashboard_period_today", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14295, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14475, 50),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 13975, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13263, 38),
      ))
    }

@delegate:ResourceContentHash(1_076_850_008)
internal val Res.string.dashboard_period_year: StringResource by lazy {
      StringResource("string:dashboard_period_year", "dashboard_period_year", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14330, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14526, 41),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 14014, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13302, 41),
      ))
    }

@delegate:ResourceContentHash(1_932_253_645)
internal val Res.string.dashboard_probe_all: StringResource by lazy {
      StringResource("string:dashboard_probe_all", "dashboard_probe_all", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14372, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14568, 35),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 14056, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13344, 31),
      ))
    }

@delegate:ResourceContentHash(1_431_392_955)
internal val Res.string.dashboard_probe_rename_action: StringResource by lazy {
      StringResource("string:dashboard_probe_rename_action", "dashboard_probe_rename_action", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14408, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14604, 49),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 14092, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13376, 45),
      ))
    }

@delegate:ResourceContentHash(-83_265_988)
internal val Res.string.dashboard_probe_rename_label: StringResource by lazy {
      StringResource("string:dashboard_probe_rename_label", "dashboard_probe_rename_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14458, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14654, 56),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 14142, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13422, 52),
      ))
    }

@delegate:ResourceContentHash(-1_767_483_068)
internal val Res.string.dashboard_probe_rename_title: StringResource by lazy {
      StringResource("string:dashboard_probe_rename_title", "dashboard_probe_rename_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14519, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14711, 60),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 14199, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13475, 52),
      ))
    }

@delegate:ResourceContentHash(-4_986_912)
internal val Res.string.dashboard_top_days_title: StringResource by lazy {
      StringResource("string:dashboard_top_days_title", "dashboard_top_days_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14580, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14772, 80),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 14260, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13528, 80),
      ))
    }

@delegate:ResourceContentHash(661_378_678)
internal val Res.string.date_format: StringResource by lazy {
      StringResource("string:date_format", "date_format", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14665, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14853, 47),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 14345, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13609, 47),
      ))
    }

@delegate:ResourceContentHash(-1_124_595_024)
internal val Res.string.deck_configuration_deck_name: StringResource by lazy {
      StringResource("string:deck_configuration_deck_name", "deck_configuration_deck_name", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14791, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14987, 52),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 14483, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13739, 48),
      ))
    }

@delegate:ResourceContentHash(1_741_622_701)
internal val Res.string.deck_configuration_deck_name_text: StringResource by lazy {
      StringResource("string:deck_configuration_deck_name_text", "deck_configuration_deck_name_text", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14713, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14901, 85),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 14393, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13657, 81),
      ))
    }

@delegate:ResourceContentHash(-1_077_517_832)
internal val Res.string.deck_configuration_deck_size: StringResource by lazy {
      StringResource("string:deck_configuration_deck_size", "deck_configuration_deck_size", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14848, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15040, 60),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 14540, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13788, 48),
      ))
    }

@delegate:ResourceContentHash(-1_201_342_264)
internal val Res.string.deck_configuration_hand_size: StringResource by lazy {
      StringResource("string:deck_configuration_hand_size", "deck_configuration_hand_size", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14909, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15101, 56),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 14601, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13837, 48),
      ))
    }

@delegate:ResourceContentHash(1_350_907_735)
internal val Res.string.decks_cards: StringResource by lazy {
      StringResource("string:decks_cards", "decks_cards", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14970, 27),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15158, 27),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 14658, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13886, 27),
      ))
    }

@delegate:ResourceContentHash(-2_607_359)
internal val Res.string.decks_no_decks: StringResource by lazy {
      StringResource("string:decks_no_decks", "decks_no_decks", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14998, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15186, 58),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 14686, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13914, 46),
      ))
    }

@delegate:ResourceContentHash(-1_578_780_419)
internal val Res.string.decks_title: StringResource by lazy {
      StringResource("string:decks_title", "decks_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15045, 27),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15245, 27),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 14745, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13961, 27),
      ))
    }

@delegate:ResourceContentHash(-949_515_759)
internal val Res.string.delete: StringResource by lazy {
      StringResource("string:delete", "delete", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15073, 26),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15273, 22),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 14777, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13989, 22),
      ))
    }

@delegate:ResourceContentHash(-196_878_599)
internal val Res.string.dismiss: StringResource by lazy {
      StringResource("string:dismiss", "dismiss", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15100, 23),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15296, 19),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 14804, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14012, 27),
      ))
    }

@delegate:ResourceContentHash(873_757_768)
internal val Res.string.distance_to_kernel: StringResource by lazy {
      StringResource("string:distance_to_kernel", "distance_to_kernel", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15124, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15316, 46),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 14832, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14040, 46),
      ))
    }

@delegate:ResourceContentHash(1_774_360_792)
internal val Res.string.doc_conclusion: StringResource by lazy {
      StringResource("string:doc_conclusion", "doc_conclusion", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15167, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15363, 50),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 14875, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14087, 50),
      ))
    }

@delegate:ResourceContentHash(631_814_567)
internal val Res.string.doc_distance_km: StringResource by lazy {
      StringResource("string:doc_distance_km", "doc_distance_km", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15218, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15414, 43),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 14926, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14138, 43),
      ))
    }

@delegate:ResourceContentHash(1_753_299_580)
internal val Res.string.doc_export_pdf: StringResource by lazy {
      StringResource("string:doc_export_pdf", "doc_export_pdf", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15262, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15458, 42),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 14970, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14182, 42),
      ))
    }

@delegate:ResourceContentHash(-1_690_897_760)
internal val Res.string.doc_gld360_id: StringResource by lazy {
      StringResource("string:doc_gld360_id", "doc_gld360_id", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15309, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15501, 37),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 15017, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14225, 37),
      ))
    }

@delegate:ResourceContentHash(-1_253_572_373)
internal val Res.string.doc_intensity_ka: StringResource by lazy {
      StringResource("string:doc_intensity_ka", "doc_intensity_ka", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15347, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15539, 44),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 15055, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14263, 44),
      ))
    }

@delegate:ResourceContentHash(-8_708_437)
internal val Res.string.doc_interpretation: StringResource by lazy {
      StringResource("string:doc_interpretation", "doc_interpretation", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15554, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15746, 46),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 15270, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14466, 46),
      ))
    }

@delegate:ResourceContentHash(-1_217_391_780)
internal val Res.string.doc_interpretation_loading: StringResource by lazy {
      StringResource("string:doc_interpretation_loading", "doc_interpretation_loading", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15392, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15584, 62),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 15104, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14308, 66),
      ))
    }

@delegate:ResourceContentHash(295_976_388)
internal val Res.string.doc_interpretation_unavailable: StringResource by lazy {
      StringResource("string:doc_interpretation_unavailable", "doc_interpretation_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15455, 98),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15647, 98),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 15171, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14375, 90),
      ))
    }

@delegate:ResourceContentHash(-1_237_143_936)
internal val Res.string.doc_nsg_label: StringResource by lazy {
      StringResource("string:doc_nsg_label", "doc_nsg_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15601, 25),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15793, 25),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 15317, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14513, 25),
      ))
    }

@delegate:ResourceContentHash(-689_123_852)
internal val Res.string.doc_nsg_unit: StringResource by lazy {
      StringResource("string:doc_nsg_unit", "doc_nsg_unit", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15627, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15819, 40),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 15343, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14539, 44),
      ))
    }

@delegate:ResourceContentHash(-653_538_892)
internal val Res.string.doc_observations: StringResource by lazy {
      StringResource("string:doc_observations", "doc_observations", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15672, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15860, 52),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 15388, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14584, 48),
      ))
    }

@delegate:ResourceContentHash(319_904_325)
internal val Res.string.doc_polarity_negative: StringResource by lazy {
      StringResource("string:doc_polarity_negative", "doc_polarity_negative", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15725, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15913, 53),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 15441, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14633, 53),
      ))
    }

@delegate:ResourceContentHash(-504_202_790)
internal val Res.string.doc_polarity_positive: StringResource by lazy {
      StringResource("string:doc_polarity_positive", "doc_polarity_positive", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15779, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15967, 49),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 15495, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14687, 49),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("cert_incidence_indirect_only", Res.string.cert_incidence_indirect_only)
  map.put("cert_incidence_probability_desc", Res.string.cert_incidence_probability_desc)
  map.put("cert_incidence_probability_title", Res.string.cert_incidence_probability_title)
  map.put("cert_incidence_unlikely", Res.string.cert_incidence_unlikely)
  map.put("cert_nsg_avg_intensity", Res.string.cert_nsg_avg_intensity)
  map.put("cert_nsg_avg_sensors", Res.string.cert_nsg_avg_sensors)
  map.put("cert_nsg_comparison_section", Res.string.cert_nsg_comparison_section)
  map.put("cert_nsg_density_section", Res.string.cert_nsg_density_section)
  map.put("cert_nsg_density_title", Res.string.cert_nsg_density_title)
  map.put("cert_nsg_detected_impacts", Res.string.cert_nsg_detected_impacts)
  map.put("cert_nsg_level_high", Res.string.cert_nsg_level_high)
  map.put("cert_nsg_level_low", Res.string.cert_nsg_level_low)
  map.put("cert_nsg_level_moderate", Res.string.cert_nsg_level_moderate)
  map.put("cert_nsg_location_label", Res.string.cert_nsg_location_label)
  map.put("cert_nsg_max_intensity", Res.string.cert_nsg_max_intensity)
  map.put("cert_nsg_measured_label", Res.string.cert_nsg_measured_label)
  map.put("cert_nsg_measured_network", Res.string.cert_nsg_measured_network)
  map.put("cert_nsg_median_intensity", Res.string.cert_nsg_median_intensity)
  map.put("cert_nsg_methodology", Res.string.cert_nsg_methodology)
  map.put("cert_nsg_no_notable_impacts", Res.string.cert_nsg_no_notable_impacts)
  map.put("cert_nsg_notable_activity_title", Res.string.cert_nsg_notable_activity_title)
  map.put("cert_nsg_notable_values", Res.string.cert_nsg_notable_values)
  map.put("cert_nsg_period_suffix", Res.string.cert_nsg_period_suffix)
  map.put("cert_nsg_share_title", Res.string.cert_nsg_share_title)
  map.put("cert_nsg_standards_text", Res.string.cert_nsg_standards_text)
  map.put("cert_nsg_standards_title", Res.string.cert_nsg_standards_title)
  map.put("cert_nsg_title", Res.string.cert_nsg_title)
  map.put("cert_nsg_vs_ng", Res.string.cert_nsg_vs_ng)
  map.put("cert_nsg_vs_ng_title", Res.string.cert_nsg_vs_ng_title)
  map.put("cert_nsg_your_site", Res.string.cert_nsg_your_site)
  map.put("cert_nsg_zone_0_1km", Res.string.cert_nsg_zone_0_1km)
  map.put("cert_nsg_zone_1_2km", Res.string.cert_nsg_zone_1_2km)
  map.put("cert_nsg_zone_network", Res.string.cert_nsg_zone_network)
  map.put("cert_physical_damage", Res.string.cert_physical_damage)
  map.put("cert_reco_check_equipment", Res.string.cert_reco_check_equipment)
  map.put("cert_reco_inspect", Res.string.cert_reco_inspect)
  map.put("cert_reco_insurance", Res.string.cert_reco_insurance)
  map.put("cert_reco_monitoring", Res.string.cert_reco_monitoring)
  map.put("cert_reco_no_action", Res.string.cert_reco_no_action)
  map.put("cert_reco_surge_protectors", Res.string.cert_reco_surge_protectors)
  map.put("cert_reco_verify", Res.string.cert_reco_verify)
  map.put("checkout_return_activated", Res.string.checkout_return_activated)
  map.put("checkout_return_activating", Res.string.checkout_return_activating)
  map.put("checkout_return_cancel_text", Res.string.checkout_return_cancel_text)
  map.put("checkout_return_cancel_title", Res.string.checkout_return_cancel_title)
  map.put("checkout_return_close", Res.string.checkout_return_close)
  map.put("checkout_return_delayed", Res.string.checkout_return_delayed)
  map.put("checkout_return_login_needed", Res.string.checkout_return_login_needed)
  map.put("checkout_return_signing_in", Res.string.checkout_return_signing_in)
  map.put("checkout_return_success_title", Res.string.checkout_return_success_title)
  map.put("confirm", Res.string.confirm)
  map.put("consultation_expired", Res.string.consultation_expired)
  map.put("consultation_loading", Res.string.consultation_loading)
  map.put("consultation_provided_by", Res.string.consultation_provided_by)
  map.put("consultation_shared_info", Res.string.consultation_shared_info)
  map.put("consultation_title", Res.string.consultation_title)
  map.put("dashboard_daily_chart_title", Res.string.dashboard_daily_chart_title)
  map.put("dashboard_header_12months", Res.string.dashboard_header_12months)
  map.put("dashboard_header_30days", Res.string.dashboard_header_30days)
  map.put("dashboard_header_90days", Res.string.dashboard_header_90days)
  map.put("dashboard_header_today", Res.string.dashboard_header_today)
  map.put("dashboard_impacts_cg", Res.string.dashboard_impacts_cg)
  map.put("dashboard_including_today", Res.string.dashboard_including_today)
  map.put("dashboard_loading_error", Res.string.dashboard_loading_error)
  map.put("dashboard_monthly_chart_title", Res.string.dashboard_monthly_chart_title)
  map.put("dashboard_no_data", Res.string.dashboard_no_data)
  map.put("dashboard_no_impact_in_period", Res.string.dashboard_no_impact_in_period)
  map.put("dashboard_period_month", Res.string.dashboard_period_month)
  map.put("dashboard_period_quarter", Res.string.dashboard_period_quarter)
  map.put("dashboard_period_today", Res.string.dashboard_period_today)
  map.put("dashboard_period_year", Res.string.dashboard_period_year)
  map.put("dashboard_probe_all", Res.string.dashboard_probe_all)
  map.put("dashboard_probe_rename_action", Res.string.dashboard_probe_rename_action)
  map.put("dashboard_probe_rename_label", Res.string.dashboard_probe_rename_label)
  map.put("dashboard_probe_rename_title", Res.string.dashboard_probe_rename_title)
  map.put("dashboard_top_days_title", Res.string.dashboard_top_days_title)
  map.put("date_format", Res.string.date_format)
  map.put("deck_configuration_deck_name", Res.string.deck_configuration_deck_name)
  map.put("deck_configuration_deck_name_text", Res.string.deck_configuration_deck_name_text)
  map.put("deck_configuration_deck_size", Res.string.deck_configuration_deck_size)
  map.put("deck_configuration_hand_size", Res.string.deck_configuration_hand_size)
  map.put("decks_cards", Res.string.decks_cards)
  map.put("decks_no_decks", Res.string.decks_no_decks)
  map.put("decks_title", Res.string.decks_title)
  map.put("delete", Res.string.delete)
  map.put("dismiss", Res.string.dismiss)
  map.put("distance_to_kernel", Res.string.distance_to_kernel)
  map.put("doc_conclusion", Res.string.doc_conclusion)
  map.put("doc_distance_km", Res.string.doc_distance_km)
  map.put("doc_export_pdf", Res.string.doc_export_pdf)
  map.put("doc_gld360_id", Res.string.doc_gld360_id)
  map.put("doc_intensity_ka", Res.string.doc_intensity_ka)
  map.put("doc_interpretation", Res.string.doc_interpretation)
  map.put("doc_interpretation_loading", Res.string.doc_interpretation_loading)
  map.put("doc_interpretation_unavailable", Res.string.doc_interpretation_unavailable)
  map.put("doc_nsg_label", Res.string.doc_nsg_label)
  map.put("doc_nsg_unit", Res.string.doc_nsg_unit)
  map.put("doc_observations", Res.string.doc_observations)
  map.put("doc_polarity_negative", Res.string.doc_polarity_negative)
  map.put("doc_polarity_positive", Res.string.doc_polarity_positive)
}
